export const addTypeToFeatures = <F, T>(features: F[], type: T) =>
	features?.map(feature => ({
		...feature,
		type
	}))
